export default {
  /**
   * Устанавливаем авторизован ли пользователь
   * @param state
   * @param {boolean} payload
   */
  setIsAuthorized(state, payload = false) {
    state.isAuthorized = payload;
  },
  setEmailUser(state, payload = '') {
    state.email = payload;
  },
  setFullNameUser(state, payload = '') {
    const [lastName, name, secondName] = payload.split(' ');

    state.fullName = payload;
    state.lastName = lastName;
    state.secondName = secondName;
    state.name = name;
  },
  setUserData(state, profile = {}) {
    if (typeof profile.email === 'string') {
      state.email = profile.email;
    }
    if (typeof profile.emailInitial === 'string') {
      state.emailInitial = profile.emailInitial;
    }
    if (typeof profile.firstName === 'string') {
      state.name = profile.firstName;
    }
    if (typeof profile.lastName === 'string') {
      state.lastName = profile.lastName;
    }
    if (typeof profile.secondName === 'string') {
      state.secondName = profile.secondName;
    }
    if (typeof profile.firstName === 'string' || typeof profile.lastName === 'string') {
      state.fullName = [profile.lastName, profile.firstName, profile.secondName].filter(item => item).join(' ');
    }
    if (typeof profile.phone === 'string') {
      state.phone = profile.phone;
    }
    if (typeof profile.phoneInitial === 'string') {
      state.phoneInitial = profile.phoneInitial;
    }
    if (typeof profile.phoneMobile === 'string') {
      state.phoneMobile = profile.phoneMobile;
    }
    if (typeof profile.inn === 'string') {
      state.inn = profile.inn;
    }
    if (typeof profile.organizationName === 'string') {
      state.organizationName = profile.organizationName;
    }
    if (typeof profile.legalAddress === 'string') {
      state.legalAddress = profile.legalAddress;
    }
    if (typeof profile.kpp === 'string') {
      state.kpp = profile.kpp;
    }
    if (typeof profile.bik === 'string') {
      state.bik = profile.bik;
    }
    if (typeof profile.correspondentAccount === 'string') {
      state.correspondentAccount = profile.correspondentAccount;
    }
    if (typeof profile.checkingAccount === 'string') {
      state.checkingAccount = profile.checkingAccount;
    }
    if (typeof profile.bankName === 'string') {
      state.bankName = profile.bankName;
    }
  },
  setCanFullChangeProfile(state, canFullChangeProfile = false) {
    state.canFullChangeProfile = canFullChangeProfile;
  },
  setIsAgreeWithData(state, isAgreeWithData = true) {
    state.isAgreeWithData = isAgreeWithData;
  },
};
